/* eslint-disable no-unused-vars */
import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Label, Row } from "reactstrap"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"

const AddFamilleFournisseur = props => {
  const [code, setCode] = useState("")
  const [etatCode, setEtatCode] = useState(false)
  const [name, setName] = useState("")

  const save = async () => {
    if (name != "" && code != "") {
      const res = await API.post("famille/fournisseur/add", {
        code: code,
        name: name,
      }).then(res => {
        if (res.data.status == 200) {
          setEtatCode(false)
          props.setSection(1)
        } else {
          setEtatCode(true)
        }
      })
    }
  }
  return (
    <React.Fragment>
      <div>
        <Row>
          {etatCode ? (
            <div className="alert alert-danger">
              <strong>Code deja utilisé!</strong>
            </div>
          ) : null}
          <AvForm>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Code")}
                  </Label>
                  <AvField
                    name="code"
                    placeholder="Entrer code"
                    type="text"
                    errorMessage="* Code obligatoire"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    onChange={e => setCode(e.target.value)}
                    maxlength="5"
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Famille fournisseur")}
                  </Label>
                  <AvField
                    name="Famille fournisseur"
                    placeholder="Entrer famille fournisseur"
                    type="text"
                    errorMessage="* Famille fournisseur obligatoire"
                    className="form-control"
                    required
                    onChange={e => setName(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  className="text-center mt-4"
                >
                  <Button
                    type="button"
                    color="warning"
                    className="btn btn-warning  mb-2 me-2"
                    onClick={props.back}
                  >
                    {props.t("Annuler")}
                  </Button>
                </div>
              </Col>
              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  className="text-center mt-4"
                >
                  <button
                    type="sunmit"
                    className="btn btn-primary "
                    onClick={save}
                  >
                    {props.t("Confirmer")}
                  </button>
                </div>
              </Col>
            </div>
          </AvForm>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default withTranslation()(AddFamilleFournisseur)
AddFamilleFournisseur.propTypes = {
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
